import { memo } from 'react'
import Skeleton from '@mui/material/Skeleton'

const ButtonSkeleton = () => <Skeleton variant="rectangular" height={50} />

export default memo(ButtonSkeleton)
